import { render, staticRenderFns } from "./acuerdos.vue?vue&type=template&id=fcccb3a8&scoped=true"
import script from "./acuerdos.vue?vue&type=script&lang=js"
export * from "./acuerdos.vue?vue&type=script&lang=js"
import style0 from "./acuerdos.vue?vue&type=style&index=0&id=fcccb3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcccb3a8",
  null
  
)

export default component.exports